<template>
	<div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12">
		<slot></slot>
	</div>
</template>

<script>
    export default {
        name: "DefaultCard"
    }
</script>

<style scoped>

</style>
